<top-bar-filters
  [reactiveForm]="filtersForm"
  [formLayoutConfig]="filtersLayoutConfig"
  [formControlsConfigMap]="filtersConfigMap"
  [valuesMap]="valuesMap"
  (updateValuesMap)="updateValuesMap($event)"
  (onApply)="applyFilters()"
  (onClear)="clearFilters()"
>
</top-bar-filters>

@if (error) {
  <div class="cat__error">{{ error }}</div>
}

@if (loading) {
  <div class="loading__message d-flex align-items-center">
    <mat-spinner [diameter]="20"></mat-spinner>
    <span class="loading__message-text ml-3">Loading real-time data, please wait…</span>
  </div>
}

@if (summary && !loading) {
  <div class="cat__charts d-flex">
    <div class="cat__chart-card">
      <div class="cat__chart-header">
        <p class="cat__chart-title">Tickets by Type <span class="cat__chart-top5">(Top 5)</span></p>
        <custom-dropdown-control
          controlName="filterByType"
          [reactiveForm]="chartFiltersForm"
          [controlConfig]="typeChartFilterConfig"
          (closed)="loadTickets()"
        ></custom-dropdown-control>
      </div>
      <div class="cat__chart-body">
        <div class="cat__chart-wrapper">
          <canvas
            baseChart
            [type]="'doughnut'"
            [data]="typeChartData"
            [options]="doughnutOptions"
            [plugins]="chartPlugins"
          ></canvas>
        </div>
        <div class="cat__chart-legend">
          @for (item of typeChartLegend; track item.label) {
            <div class="cat__legend-item">
              <span class="cat__legend-dot" [style.background]="item.color"></span>
              <div class="cat__legend-text-group">
                <span class="cat__legend-name">{{ item.label }}</span>
                <span class="cat__legend-count">({{ item.count.toLocaleString() }})</span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="cat__chart-card">
      <div class="cat__chart-header">
        <p class="cat__chart-title">Tickets by Sub-Type <span class="cat__chart-top5">(Top 5)</span></p>
        <custom-dropdown-control
          controlName="filterBySubType"
          [reactiveForm]="chartFiltersForm"
          [controlConfig]="subTypeChartFilterConfig"
          (closed)="loadTickets()"
        ></custom-dropdown-control>
      </div>
      <div class="cat__chart-body">
        <div class="cat__chart-wrapper">
          <canvas
            baseChart
            [type]="'doughnut'"
            [data]="subTypeChartData"
            [options]="doughnutOptions"
            [plugins]="chartPlugins"
          ></canvas>
        </div>
        <div class="cat__chart-legend">
          @for (item of subTypeChartLegend; track item.label) {
            <div class="cat__legend-item">
              <span class="cat__legend-dot" [style.background]="item.color"></span>
              <div class="cat__legend-text-group">
                <span class="cat__legend-name">{{ item.label }}</span>
                <span class="cat__legend-count">({{ item.count.toLocaleString() }})</span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="cat__chart-card">
      <div class="cat__chart-header">
        <p class="cat__chart-title">Tickets by Item <span class="cat__chart-top5">(Top 5)</span></p>
        <custom-dropdown-control
          controlName="filterByItem"
          [reactiveForm]="chartFiltersForm"
          [controlConfig]="itemChartFilterConfig"
          (closed)="loadTickets()"
        ></custom-dropdown-control>
      </div>
      <div class="cat__chart-body">
        <div class="cat__chart-wrapper">
          <canvas
            baseChart
            [type]="'doughnut'"
            [data]="itemChartData"
            [options]="doughnutOptions"
            [plugins]="chartPlugins"
          ></canvas>
        </div>
        <div class="cat__chart-legend">
          @for (item of itemChartLegend; track item.label) {
            <div class="cat__legend-item">
              <span class="cat__legend-dot" [style.background]="item.color"></span>
              <div class="cat__legend-text-group">
                <span class="cat__legend-name">{{ item.label }}</span>
                <span class="cat__legend-count">({{ item.count.toLocaleString() }})</span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (loadingTickets && !loading) {
  <div class="cat__loading d-flex justify-content-center align-items-center" style="min-height: 100px">
    <mat-spinner [diameter]="28"></mat-spinner>
  </div>
}

@if (ticketPageData && !loading && !loadingTickets) {
  <div class="cat__table">
    <table mat-table [dataSource]="ticketPageData.data" class="udt-table w-100">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>Ticket #</th>
        <td mat-cell *matCellDef="let row">
          <a class="cat__ticket-link" [routerLink]="['/secured/managed-services/tickets', row.id]">{{ row.id }}</a>
        </td>
      </ng-container>
      <ng-container matColumnDef="dateEntered">
        <th mat-header-cell *matHeaderCellDef>Date Entered</th>
        <td mat-cell *matCellDef="let row">{{ row.dateEntered | hubDate }}</td>
      </ng-container>
      <ng-container matColumnDef="closedDate">
        <th mat-header-cell *matHeaderCellDef>Date Closed</th>
        <td mat-cell *matCellDef="let row">{{ row.closedDate ? (row.closedDate | hubDate) : '—' }}</td>
      </ng-container>
      <ng-container matColumnDef="contact">
        <th mat-header-cell *matHeaderCellDef>Contact</th>
        <td mat-cell *matCellDef="let row">{{ row.contactName ?? '—' }}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row">{{ row.status }}</td>
      </ng-container>
      <ng-container matColumnDef="summary">
        <th mat-header-cell *matHeaderCellDef>Summary</th>
        <td mat-cell *matCellDef="let row" class="cat__summary-cell">{{ row.summary }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator
      [length]="ticketPageData.total"
      [pageSize]="pageSize"
      [pageIndex]="currentPage - 1"
      [pageSizeOptions]="[25, 50, 100, 200]"
      showFirstLastButtons
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  </div>
}
